import script from "./LegalCompliance.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalCompliance.vue?vue&type=script&setup=true&lang=js"

import "./LegalCompliance.vue?vue&type=style&index=0&id=10d5f546&lang=css"

const __exports__ = script;

export default __exports__